export default __webpack_public_path__ + "static/media/43.29722624.png";